module.exports = __webpack_public_path__ + "static/media/knowledge.d543c498.png";